import * as THREE from "three";
import SolidGeometry from "./solid-geometry";

// Eixo em y: seção largura x profundidade (elíptica se diferentes) e comprimento = altura
export default class CylinderGeometry extends SolidGeometry {
  constructor(color, { width, height, depth }, positions) {
    const geometry = new THREE.CylinderGeometry(0.5, 0.5, 1, 64);
    geometry.scale(width, height, depth);
    super("cylinder", color, geometry, positions);
  }
}
